import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
} from "@angular/core";
import { LineItemMonitorDataService } from "../line-item-monitor-data.service";
import {
  GridHeader,
  GridValue,
  LineItemMonitorMeta,
} from "../line-item-monitor.model";
import { getUpdatedPeriodData } from "../util";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-trend-lim",
  templateUrl: "./trend-lim.component.html",
  styleUrls: ["./trend-lim.component.scss"],
})
export class TrendLimComponent implements OnInit {
  @Input() ticker: string;
  @Input() lineItemsMeta: LineItemMonitorMeta;
  @Output() updatePeriod: EventEmitter<any> = new EventEmitter();

  isLoading: boolean;
  gridHeader: GridHeader = {
    level1: [
      {
        label: "",
        subscript: "",
        rowspan: "2",
        colspan: "2",
      },
    ],
    level2: [],
  };
  widthConfig = ["225px", "30px"];
  gridValues: Array<GridValue> = [];
  onPeriodChange = getUpdatedPeriodData.bind(this, { growthType: "yoy" });
  constructor(
    private dataService: LineItemMonitorDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    this.lineItemsMeta.period_list.forEach((period) => {
      const header = {
        label: `${period}`,
        colspan: "2",
      };
      this.gridHeader.level1.push(header);
      this.widthConfig.push("86px", "98px");
      this.gridHeader.level2.push([
        {
          label: "Consensus",
        },
        {
          label: "YoY",
        },
      ]);
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.ticker &&
        changes.ticker.previousValue !== changes.ticker.currentValue) ||
      (changes.lineItemsMeta &&
        changes.lineItemsMeta.previousValue !==
          changes.lineItemsMeta.currentValue)
    ) {
      const payload = {
        ticker: this.ticker,
        growthType: "yoy",
        param_ids: this.lineItemsMeta.line_items.map(
          (line) => line.dapparameterid,
        ),
      };
      this.gridValues = [];
      this.isLoading = true;
      this.lineItemsMeta.period_list.forEach((period) => {
        this.getPeriodData({ ...payload, period: [period] });
      });
      this.gridHeader.level1[0].subscript = `All numbers in ${this.lineItemsMeta.currency_value} unless stated otherwise`;
    }
  }

  getPeriodData(payload) {
    this.dataService.getLIMData(payload).subscribe((response) => {
      this.mapApiToGridData(response);
    });
  }
  mapApiToGridData(response) {
    response.data.forEach((periodData) => {
      //find all indexes for this period, we allow duplicate periods in grid
      const periodIndexes = this.lineItemsMeta.period_list
        .map((period, index) => {
          return period === periodData.period ? index : "";
        })
        .filter((idx) => idx !== "");

      periodData.data.forEach((row) => {
        const rowIndex = this.lineItemsMeta.rowHeaders[row.dap_id].rowIndex;
        const values = [
          {
            ...this.dataService.getFormat(row.current, true, row.unit, true),
          },
          {
            ...this.dataService.getFormat(
              row.yoy_value,
              false,
              row.unit,
              false,
            ),
          },
        ];
        if (!this.gridValues[rowIndex]) {
          this.gridValues[rowIndex] = new GridValue();
        }
        if (!this.gridValues[rowIndex].values) {
          this.gridValues[rowIndex].values = Array(4);
        }

        const rowValues = {
          id: row.dap_id,
          header: this.lineItemsMeta.rowHeaders[row.dap_id].header,
          values: [...this.gridValues[rowIndex].values],
        };
        periodIndexes.forEach((idx) => (rowValues.values[idx] = values));
        this.gridValues[rowIndex] = rowValues;
      });
    });
    this.gridValues = [...this.gridValues];
    this.isLoading = false;
    // console.log(this.gridValues);
  }
}
